function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2016(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2.36,
    height: 8.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.3933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 4.045
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 8.09,
    width: 2.36,
    height: 15.57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.3933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 15.875
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 23.66,
    width: 2.36,
    height: 22.16,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.472
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 34.74
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 45.82,
    width: 2.36,
    height: 57.27,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.33714285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 74.455
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.09,
    width: 2.36,
    height: 58.24,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.3933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 132.21
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 161.33,
    width: 2.36,
    height: 64.63,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.3933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 193.645
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 225.96,
    width: 2.36,
    height: 66.84,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 259.38
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 292.79,
    width: 2.36,
    height: 75.94,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.472
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 330.76
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 368.74,
    width: 2.36,
    height: 76.7,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 407.09000000000003
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 445.43,
    width: 2.36,
    height: 78.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.59
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 484.785
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 524.14,
    width: 2.36,
    height: 86.84,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.3933333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 567.56
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 610.98,
    width: 2.36,
    height: 89.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.2622222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 1.18,
    y: 655.49
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 0,
    width: 11.72,
    height: 30.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9533333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 8.22,
    y: 15.02
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.07,
    y: 0,
    width: 13.46,
    height: 30.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2433333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 20.8,
    y: 15.02
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.53,
    y: 0,
    width: 14.48,
    height: 30.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.81
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.77,
    y: 15.02
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.02,
    y: 0,
    width: 15.53,
    height: 30.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7255555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.785000000000004,
    y: 15.02
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.55,
    y: 0,
    width: 15.68,
    height: 30.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.92
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 65.39,
    y: 15.02
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.23,
    y: 0,
    width: 17.77,
    height: 30.04,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.22125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 82.11500000000001,
    y: 15.02
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 0,
    width: 22.45,
    height: 30.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.225,
    y: 15.02
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.44,
    y: 0,
    width: 23.52,
    height: 30.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.352
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.2,
    y: 15.02
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 136.96,
    y: 0,
    width: 25.13,
    height: 30.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.1883333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.525,
    y: 15.02
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.09,
    y: 0,
    width: 26.02,
    height: 30.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 175.1,
    y: 15.02
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.11,
    y: 0,
    width: 32.52,
    height: 30.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.37,
    y: 15.02
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.63,
    y: 0,
    width: 43.02,
    height: 30.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3377777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 242.14,
    y: 15.02
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.65,
    y: 0,
    width: 44.71,
    height: 30.04,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 286.005,
    y: 15.02
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 308.36,
    y: 0,
    width: 50.94,
    height: 30.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 333.83000000000004,
    y: 15.02
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 359.3,
    y: 0,
    width: 60.16,
    height: 30.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.38,
    y: 15.02
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 419.46,
    y: 0,
    width: 65.48,
    height: 30.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.2,
    y: 15.02
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.93,
    y: 0,
    width: 70.17,
    height: 30.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.006666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.015,
    y: 15.02
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.11,
    y: 0,
    width: 71.38,
    height: 30.04,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3377777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 590.8,
    y: 15.02
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 626.49,
    y: 0,
    width: 73.51,
    height: 30.04,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.51
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 663.245,
    y: 15.02
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 30.04,
    width: 63.87,
    height: 38.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.65
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 49.165
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 68.29,
    width: 63.87,
    height: 42.25,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.041666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 89.415
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 110.54,
    width: 63.87,
    height: 48.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 134.68
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 158.82,
    width: 63.87,
    height: 60.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.046
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 189.165
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 219.51,
    width: 63.87,
    height: 67.03,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 253.02499999999998
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 286.54,
    width: 63.87,
    height: 72.89,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.387
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 322.985
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 359.43,
    width: 63.87,
    height: 78.01,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 398.435
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 437.44,
    width: 63.87,
    height: 83.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.387
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 479.36
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 521.28,
    width: 63.87,
    height: 88.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 565.62
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.36,
    y: 609.96,
    width: 63.87,
    height: 90.04,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 34.295,
    y: 654.98
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.23,
    y: 30.04,
    width: 63.49,
    height: 94.62,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.698
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.97500000000001,
    y: 77.35
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.71,
    y: 30.04,
    width: 63.87,
    height: 94.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.913076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.645,
    y: 77.35
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 193.58,
    y: 30.04,
    width: 71.95,
    height: 94.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.540909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.555,
    y: 77.35
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.53,
    y: 30.04,
    width: 84.09,
    height: 94.62,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.015
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307.575,
    y: 77.35
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.62,
    y: 30.04,
    width: 95.5,
    height: 94.62,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.770000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 397.37,
    y: 77.35
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.12,
    y: 30.04,
    width: 116.14,
    height: 94.62,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.517142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.19,
    y: 77.35
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 561.26,
    y: 30.04,
    width: 138.74,
    height: 94.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.513333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 630.63,
    y: 77.35
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.23,
    y: 124.66,
    width: 129.32,
    height: 137.48,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.776666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.89,
    y: 193.39999999999998
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.23,
    y: 262.14,
    width: 129.32,
    height: 142.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.931999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.89,
    y: 333.555
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.23,
    y: 404.97,
    width: 129.32,
    height: 146.45,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.947692307692307
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.89,
    y: 478.19500000000005
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.23,
    y: 551.42,
    width: 129.32,
    height: 148.58,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.237142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 130.89,
    y: 625.7099999999999
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.55,
    y: 124.66,
    width: 136.07,
    height: 154.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.118888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.58500000000004,
    y: 201.93
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 331.62,
    y: 124.66,
    width: 183.97,
    height: 154.54,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.049090909090909
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.605,
    y: 201.93
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.58,
    y: 124.66,
    width: 184.42,
    height: 154.54,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.077142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 607.7900000000001,
    y: 201.93
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.55,
    y: 279.2,
    width: 180.77,
    height: 191.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.128333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.935,
    y: 374.71
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.55,
    y: 470.23,
    width: 180.77,
    height: 229.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.08555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 285.935,
    y: 585.115
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.32,
    y: 279.2,
    width: 323.68,
    height: 420.8,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.425454545454546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.16,
    y: 489.6
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2016);
export default __webpack_public_path__ + "static/media/2016.59d9c2061a0740dbdf7edf56e73dee3d.svg";
export { ForwardRef as ReactComponent };